import { z } from 'zod';

import { CALENDAR_INTERVAL } from '../dictionary';

/** Zod schema validating a calendar interval. */
export const CalendarIntervalSchema = z.nativeEnum(CALENDAR_INTERVAL);
/** Week, month, quarter or year a chart over time groups its points by. */
export type CalendarInterval = z.infer<typeof CalendarIntervalSchema>;
